require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./loans-and-credit-cards-personal-loans.json") })
        }
      }, "path---loans-and-credit-cards-personal-loans");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---loans-and-credit-cards-personal-loans!./.cache/json/loans-and-credit-cards-personal-loans.json
// module id = 2594
// module chunks = 231608221292675